// This file is generated.
export const version = '1.0.0'
